import { Tooltip } from "@mui/material";
import React from "react";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper.tsx";

import { Close, Edit } from "@mui/icons-material";

//Styles
import { withStyles } from "tss-react/mui";
import Button from "../../../../../components/CustomButtons/Button";
import GridContainer from "../../../../../components/Grid/GridContainer";
import GridItem from "../../../../../components/Grid/GridItem";
import Table from "../../../../../components/Table/Table";
import OverzichtStyle from "./OverzichtStyle";

function Overzicht({ ...props }) {
  const { classes } = props;

  const convertTableData = () => {
    let output = [];

    if (!(props.customFields === null || props.customFields === "")) {
      try {
        const customFields = JSON.parse(props.customFields);

        output = customFields.map((prop) => {
          const simpleButtons = [
            {
              color: "success",
              icon: Edit,
              tooltip: <TranslationWrapper tDefault={"Aanpassen"} tKey={"global.button.aanpassen"} />,
              click: () => props.onEdit(prop, "customFields"),
            },
            {
              color: "danger",
              icon: Close,
              tooltip: <TranslationWrapper tDefault={"Verwijderen"} tKey={"global.button.verwijderen"} />,
              click: () => props.onDelete(prop, "customFields", "DELETE"),
            },
          ].map((buttonProp, key) => {
            return (
              <Tooltip classes={{ tooltip: classes.tooltip }} key={key} placement={"bottom"} title={buttonProp.tooltip}>
                <Button
                  className={classes.actionButton}
                  color={buttonProp.color}
                  disabled={props.disableAll}
                  justIcon
                  onClick={buttonProp.click}
                  simple
                >
                  <buttonProp.icon className={classes.icon} />
                </Button>
              </Tooltip>
            );
          });

          return [
            prop.type,
            prop.name,
            prop.descr,
            prop.required ? "V" : "X",
            prop.actief ? "V" : "X",
            prop.remember ? "V" : "X",
            prop.sendToApi || prop.sendToApi == undefined ? "V" : "X",
            prop.printField || prop.printField == undefined ? "V" : "X",
            simpleButtons,
          ];
        });
      } catch (e) {}
    }

    return output;
  };

  return (
    <GridContainer>
      <GridItem lg={12} md={12} xs={12}>
        <Table
          customCellClasses={[classes.right]}
          customClassesForCells={[8]}
          customHeadCellClasses={[classes.right]}
          customHeadClassesForCells={[8]}
          tableData={convertTableData()}
          tableHead={[
            <TranslationWrapper tDefault={"Type"} tKey={"vestigingen.form.customfields.overzicht.table.head.type"} />,
            <TranslationWrapper tDefault={"Naam"} tKey={"vestigingen.form.customfields.overzicht.table.head.naam"} />,
            <TranslationWrapper
              tDefault={"Omschrijving"}
              tKey={"vestigingen.form.customfields.overzicht.table.head.omschrijving"}
            />,
            <TranslationWrapper
              tDefault={"Verplicht"}
              tKey={"vestigingen.form.customfields.overzicht.table.head.verplicht"}
              tStyle={{ writingMode: "vertical-rl", textOrientation: "mixed" }}
            />,
            <TranslationWrapper
              tDefault={"Actief"}
              tKey={"vestigingen.form.customfields.overzicht.table.head.actief"}
              tStyle={{ writingMode: "vertical-rl", textOrientation: "mixed" }}
            />,
            <TranslationWrapper
              tDefault={"Onthouden"}
              tKey={"vestigingen.form.customfields.overzicht.table.head.onthouden"}
              tStyle={{ writingMode: "vertical-rl", textOrientation: "mixed" }}
            />,
            <TranslationWrapper
              tDefault={"Send to API"}
              tKey={"vestigingen.form.customfields.overzicht.table.head.sendToApi"}
              tStyle={{ writingMode: "vertical-rl", textOrientation: "mixed" }}
            />,
            <TranslationWrapper
              tDefault={"Print field"}
              tKey={"vestigingen.form.customfields.overzicht.table.head.printField"}
              tStyle={{ writingMode: "vertical-rl", textOrientation: "mixed" }}
            />,
            <TranslationWrapper
              tDefault={"Actions"}
              tKey={"vestigingen.form.customfields.overzicht.table.head.actions"}
            />,
          ]}
        />
      </GridItem>
    </GridContainer>
  );
}

export default withStyles(Overzicht, OverzichtStyle);
